import moment from "moment";
import htmlToText from "html-to-text";

export default {
    MakePDF(prog){
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        }
        moment.locale('ru');
        const htmlToText = require('html-to-text');
        let special = ""
        let profile = ""
        let basis_profile = ""
        function getInitial(fio){
            let initial = ""
            if (fio !== ""){
                fio = fio.replaceAll("  ", " ")
                fio = fio.trim();
                initial += fio.split(' ')[1][0];
                initial +="."
                initial += fio.split(' ')[2][0];
                initial +=". "
                initial += fio.split(' ')[0];
            }
            return initial
        }
        let department = []
        if (prog.main_info.department !== null){
            department = prog.main_info.department.split(' ').slice(1);
        }
        if (prog.main_info.dep_manager === null){
            prog.main_info.dep_manager = ""
        }
        if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
            special = "Специальность"
            profile = "Направленность (профиль) программы специалитета"
        }
        else if (prog.main_info.speciality_code === '38.05.01'){
            special = "Специальность"
            profile = "Специализация программы специалитета"
        }
        else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
            special = "Направление подготовки"
            profile = "Направленность (профиль) образовательной программы"
        }
        else{
            special = "Специальность"
            profile = "Специализация образовательной программы"
        }
        if (prog.main_info.speciality_code.split('.')[1] === '05'){
            basis_profile = "специальности " + prog.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
        }
        else {
            basis_profile += "направлению подготовки " + prog.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
        }
        if (prog.main_info.creator.title === null){
            prog.main_info.creator.title = ""
        }
        let n = 0
        let n_comp = 0
        function num(){
            n = n+1
            return n
        }
        function buildTitle() {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: 'ПРОГРАММА  ПРАКТИКИ', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `«${prog.name.toUpperCase()}»`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `${special} ${prog.main_info.speciality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `${profile} – ${prog.main_info.profile}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Квалификация выпускника – ${prog.main_info.quality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Форма обучения – ${prog.main_info.edu_form}`, style: 'twelveNormal', border: [false, false, false, false]}],
                )
            }
            else{
                body.push(
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: 'ПРОГРАММА  ПРАКТИКИ', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `подготовка научных и научно-педагогических кадров в аспирантуре`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `${prog.name}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `Научная специальность`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `${prog.main_info.speciality}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `Форма обучения`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `${prog.main_info.edu_form}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
                )
            }
            return body;
        }
        function buildFedAgreed() {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push([{text: `${prog.main_info.basis} от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`, alignment:'justify', style: 'twelveNormal', border: [false, false, false, false]}],)
            }
            else {
                body.push([{text: ``, alignment:'justify', style: 'twelveNormal', border: [false, false, false, false]}],)
            }
            return body;
        }
        function buildApproval() {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Учебно-методическое управление`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Выпускающая кафедра`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Чалкина`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Н.А. Чалкина`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `${(prog.main_info.provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `${getInitial(prog.main_info.provisor)}`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],)
            }
            else {
                body.push(
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Зав. отделом докторантуры и аспирантуры`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Выпускающая кафедра`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Сизова`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Е.С. Сизова`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `${(prog.main_info.provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `${getInitial(prog.main_info.provisor)}`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],)
            }
            return body;
        }
        function buildComp(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push([{text: `\t   ${num()}. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ`, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
            }
            else{
                body.push([{text: `\t   ${num()}. ТРЕБОВАНИЯ К РЕЗУЛЬТАТАМ ОБУЧЕНИЯ ПО ПРАКТИКЕ`, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: `В результате прохождения практики обучающийся должен демонстрировать следующие результаты:`, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: `Знать: ${htmlToText.fromString(prog.competition.know, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    })}`, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: `Уметь: ${htmlToText.fromString(prog.competition.able, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    })}`, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: `Владеть: ${htmlToText.fromString(prog.competition.own, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    })}`, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]}])
            }
            return body;
        }
        function buildEval(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: `\t ${num()}. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОВЕДЕНИЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ ПО ПРАКТИКЕ`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: htmlToText.fromString(prog.eval_tool_old, {
                            wordwrap: 10000,
                            whitespaceCharacters: '\t',
                            tags:{
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                            },
                        }), style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                )
            }
            else{
                body.push([{text: ``, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
            }
            return body;
        }
        function buildCompetitionCat() {
            var body = [];
            if (prog.competition.UK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp}. Универсальные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) универсальных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.UK.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.OPK_cat.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) общепрофессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.OPK_cat.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildCompetition() {
            var body = [];
            if (prog.competition.OPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.OPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.PK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.PK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition?.DPK && prog.competition.DPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Дополнительные профессиональные компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование дополнительной профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения дополнительной профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.DPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }

        function buildSoftware() {
            var body = [];
            let n_soft = 0
            if (prog.software.length || prog.resources.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.software.forEach(function(soft) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                prog.resources.forEach(function(res) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        function buildDataBases() {
            var body = [];
            if (prog.data_bases.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.data_bases.forEach(function(db) {
                    body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }

        function buildStructure() {
            var body = [];
            body.push([{text: `№ п/п`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Разделы (этапы) практики`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание раздела (этапа) практики`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Трудоемкость (в академических часах)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
            prog.structure.forEach(function(struct) {
                body.push([{text: `${prog.structure.indexOf(struct) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${struct.part}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(struct.content, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: `${struct.time}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
            });
            body.push([{text: `Итого ${prog.main_info.load.hour} часов`, style: 'twelveNormal', colSpan: 4, border: [true, true, true, true]},{},{},{}])
            body.push([{text: ``, style: 'twelveNormal', colSpan: 4, border: [false, false, false, false]},{},{},{}])

            return body;
        }
        let titlePage = {
            info: {
                title: `Рабочая программа ${prog.main_info.discipline} ${prog.main_info.speciality} ${prog.main_info.year}`,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins:[60,40,60,60],

            header:[],
            footer:[],
            content: [
                {
                    text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
                    style: "twelveNormal", alignment: 'center',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [240,110,100],
                        heights: [8,'auto','auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${moment(prog.updated_at).format('LL')}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [50,'auto','auto',30],
                        body: buildTitle()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [30,'auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                            [{text: `Составитель ${getInitial(prog.main_info.creator.fio)}, ${prog.main_info.creator.position}, ${prog.main_info.creator.title.replaceAll("ученая степень отсутствует", "")}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.facility}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.department}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [160],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: ['auto'],
                        body: buildFedAgreed()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [20,20],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `Программа практики обсуждена на заседании кафедры ${department.join(" ")}`,  style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,120],
                        heights: ['auto'],
                        body: [
                            [{text: `${prog.main_info.approval_date} г.`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `, протокол № ${prog.main_info.protocol_num}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [140,80,100],
                        heights: [10],
                        body: [
                            [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                            [{text: `Заведующий кафедрой`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,100,30,100,100,30],
                        heights: [100,'auto','auto',10],
                        body: buildApproval()
                    }
                },
                {
                    text: `\t\t ${num()}. ТИП ПРАКТИКИ И СПОСОБ ПРОВЕДЕНИЯ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t ${n}.1.  Тип (форма проведения) практики`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.practice_type.type, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${n}.2. Способы проведения практики`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.practice_type.method, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. ЦЕЛИ  И ЗАДАЧИ  ПРАКТИКИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.purpose_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildComp()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildCompetitionCat()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,150,290],
                        heights: [],
                        body: buildCompetition()
                    }
                },
                {
                    text: `\t\t ${num()}. МЕСТО  ПРАКТИКИ В СТРУКТУРЕ ОП`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.practice_place_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. МЕСТО И ВРЕМЯ ПРОВЕДЕНИЯ  ПРАКТИКИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.practice_time_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. ОБЪЕМ ПРАКТИКИ В ЗАЧЕТНЫХ ЕДИНИЦАХ И ЕЕ ПРОДОЛЖИ ТЕЛЬНОСТЬ В НЕДЕЛЯХ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.practice_size_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. СТРУКТУРА И СОДЕРЖАНИЕ ПРАКТИКИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [20,110,230,90],
                        heights: [],
                        body: buildStructure()
                    }
                },
                {
                    text: `\t\t ${num()}. ОБРАЗОВАТЕЛЬНЫЕ, НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЕ И НАУЧНО-ПРОИЗВОДСТВЕННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ НА ПРАКТИКЕ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.edu_tech_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. ФОРМА ОТЧЕТНОСТИ ПО ПРАКТИКЕ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.report_text_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildEval()
                    }
                },
                {
                    text: `\t\t ${num()}. УЧЕБНО-МЕТОДИЧЕСКИЕ МАТЕРИАЛЫ ПО ПРАКТИКЕ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t ${n}.1. Литература`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.literature_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags: {
                            'a': { options: {
                                    hideLinkHrefIfSameAsText: true,
                                    noLinkBrackets: true},
                            },
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }),
                    style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${n}.2. Программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildSoftware()
                    }
                },
                {
                    text: `\t\t ${n}.3. Профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildDataBases()
                    }
                },
                {
                    text: `\t\t ${num()}. ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПРОВЕ ДЕНИЯ  ПРАКТИКИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.inform_tech_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify'
                },
                {
                    text: `\t\t ${num()}. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ  ПРАКТИКИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.structure_text_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify'
                },
            ],
            styles: {
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    preserveLeadingSpaces: true
                },
                twelveBold: {
                    fontSize: 12,
                    font: 'Times',
                    bold: true,
                    preserveLeadingSpaces: true
                },
            }
        };
        pdfMake.createPdf(titlePage).download(`${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    }
}